import styled, { css } from 'styled-components';
import LargestCol from 'components/LargestCol';
import Well from 'components/Well';
import { StyledPropertySelect } from '../PropertySelect';
import { ifProp } from 'styled-tools';

const RewardsCol = styled(LargestCol)`
  margin-top: 1.5em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-height: 100%;

  *:not(.DayPicker-NavBar) > button:not(.property-item) {
    padding-left: 0;
    padding-right: 0;
  }

  & > div {
    flex: 1 0 auto;

    &:first-child {
      flex: 0 1 auto;
    }
  }

  ${Well} {
    margin-top: 0;
    height: 100%;
    margin-bottom: 0;

    &.book-your-stay {
      margin-top: 1em;

      h5 {
        font-size: 1em;
      }
    }
  }

  h5 {
    font-size: 0.9em;
  }

  div[class*='col-'].offers-form-container {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;

    ${ifProp(
      'isHostBooking',
      css`
        @media screen and (max-width: ${props =>
            props.theme.breakpoints.medium}) {
          padding: 0;
        }
      `
    )}
  }

  ${StyledPropertySelect} {
    display: none;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.small}) {
    h5 {
      font-size: 1.25em;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.medium}) {
    ${Well} {
      margin-top: 0;
    }

    .rewards-note {
      font-size: 0.8em;
      margin-bottom: 0.5rem;
    }
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.large}) {
    margin-top: 0;

    ${StyledPropertySelect} {
      display: block;
    }
  }

  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    margin-top: 0.5em;
  }
`;

export default RewardsCol;
